import { siteApiSlice } from "../../app/siteApiSlice";

export interface ScoreCategoryModel {
	scoreCategoryId: number;
	name: string;
	shortName: string;
	codeName: string;
	description: string;
	order: number;
	maxScore: number;
	isProctorScored: boolean;
	isEssayTrait: boolean;
	isConstructedResponseTrait: boolean;
}

export interface GradeModel {
	gradeId: number;
	name: string;
	shortName: string;
	sortName: number;
	scoringLevelId: number;
}

export interface ScoringLevelModel {
	scoringLevelId: number;
	name: string;
	shortName: string;
}

export interface GenreModel {
	genreId: number;
	name: string;
	isEssayGenre: boolean;
	isConstructedResponseGenre: boolean;
}

const ONE_YEAR = 60 * 60 * 24 * 365;

export const lookupApiSlice = siteApiSlice.injectEndpoints({
	endpoints: (build) => ({
		getScoreCategories: build.query<ScoreCategoryModel[], void>({
			query: () => ({
				url: `/Lookup/GetScoreCategories`,
			}),
			keepUnusedDataFor: ONE_YEAR,
		}),
		getGrades: build.query<GradeModel[], void>({
			query: () => ({
				url: `/Lookup/GetGrades`,
			}),
			keepUnusedDataFor: ONE_YEAR,
		}),
		getScoringLevels: build.query<ScoringLevelModel[], void>({
			query: () => ({
				url: `/Lookup/GetScoringLevels`,
			}),
			keepUnusedDataFor: ONE_YEAR,
		}),
		getGenres: build.query<GenreModel[], void>({
			query: () => ({
				url: `/Lookup/GetGenres`,
			}),
			keepUnusedDataFor: ONE_YEAR,
		}),
	}),
});

export const {
	useGetScoreCategoriesQuery,
	useGetScoringLevelsQuery,
	useGetGenresQuery,
	useGetGradesQuery,
} = lookupApiSlice;
